import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientScreenerAnswerControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  appointmentUuid: string;
  xTENANTID?: string;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetAllScreeningPreview = ({
  pagination,
  gridSorting,
  appointmentUuid,
  xTENANTID,
}: Props): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;

  return useQuery({
    queryKey: [
      "encounter-all=screening-preview",
      pagination,
      gridSorting,
      appointmentUuid,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    enabled: !!appointmentUuid,
    queryFn: async () =>
      await new PatientScreenerAnswerControllerApi(getConfigObject())
        .getPatientScreeners(
          appointmentUuid,
          pageIndex, //page
          pagination.pageSize, //size
          sortBy,
          sortDirect, // sortDirection
           xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
